module.exports = __webpack_public_path__ + "img/179979.0ee0edc0.png";